import { Injectable } from '@angular/core';

@Injectable()
export class FormService {


    errorCSSClass = '.valid';

    errorFocusCssClass = '.valid .valid-focus';

    scrollToFirstErrorField(): boolean {
        const firstElementWithError: HTMLElement = document.querySelector(this.errorCSSClass);
        if (firstElementWithError) {

            const headerHeight = 80;
            firstElementWithError.scrollIntoView(true);

            const firstElementWithErrorFocus: HTMLElement = document.querySelector(this.errorFocusCssClass);

            if (firstElementWithErrorFocus && firstElementWithErrorFocus.classList.contains("mat-checkbox")) {
                const firstElementWithErrorFocusMatCheckBox = firstElementWithErrorFocus.querySelector("input");
                const button = document.createElement('div');
                button.innerHTML = "<div class='mat-ripple-element' style='left: 0px; top: 0px; height: 50px; width: 50px; transition-duration: 400ms; transform: scale(1);'></div>";
                console.info(firstElementWithErrorFocus.querySelector("input").nextElementSibling.appendChild(button));
                setTimeout(() => {
                    firstElementWithErrorFocusMatCheckBox.focus();
                    firstElementWithErrorFocus.querySelector("input").nextElementSibling.appendChild(button);
                    firstElementWithErrorFocusMatCheckBox.addEventListener('blur', (event) => {
                        event.stopPropagation();
                        if(firstElementWithErrorFocus){
                            firstElementWithErrorFocus.querySelector("input").nextElementSibling.removeChild(button);
                        }
                    });
                }, 100);
            } else {
                setTimeout(() => {
                    firstElementWithErrorFocus.focus();
                }, 100);
            }

            const scrolledY = window.scrollY;

            if (scrolledY) {
                window.scroll(0, scrolledY - headerHeight);
            }

            return true;
        }

        return false;
    }

}
